import React from 'react'
import { Navbar } from '../Components/Navbar'
import { Hero } from '../Components/Hero'
import { Newsletter } from '../Components/Newsletter'
import Slider from '../Components/Slider'


export const HomePage = () => {
  return (
    <div>
    
        <Hero />
        <Slider />
        <Newsletter />
        
    </div>
  )
}